<template>
  <div class="header-nav">
    <el-container>
      <div class="nav-header">
        <div class="nav-left" @click="goToHome">
          <span class="logo"></span>
          <div class="divider"></div>
          <span class="brand-name">无人车开放平台</span>
        </div>

        <div class="nav-main">
          <div class="nav-center">
            <CustomMenu
                :menus="navigationMenus"
                :active-index="activeIndex"
                submenuAlign="left"
                @select="handleSelect"
            />
          </div>
          <div class="nav-right">
            <!-- 右侧用户信息或登录按钮 -->
            <div v-if="isLoggedIn" class="user-menu-wrapper">
              <CustomMenu
                :menus="userMenus"
                :active-index="''"
                @select="handleUserMenuSelect"
                submenuAlign="right"

              />
            </div>
            <div v-else class="auth-section">
              <User style="width: 24px;height: 24px;" />
              <div class="auth-buttons">
                <span @click="handleCommand('login')">登录</span>
                <span>/</span>
                <span @click="handleCommand('register')">注册</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ArrowDown, User } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores'
import CustomMenu from '@/components/CustomMenu/index.vue'

export default {
  name: 'HeaderNav',
  components: {
    ArrowDown, User, CustomMenu
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const userStore = useUserStore()
    const activeIndex = ref('1')

    // 计算属性：基于token判断登录状态
    const isLoggedIn = computed(() => userStore.isLoggedIn && userStore.token)
    const userInfo = computed(() => userStore.userInfo)
    // const userAvatar = computed(() => userInfo.value?.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = computed(() => userInfo.value?.name || userInfo.value?.email || '用户')
    const userEmail = computed(() => userStore.getEmail || '用户')

    // 用户菜单数据结构
    const userMenus = computed(() => {
      if (!isLoggedIn.value) {
        return [{
          path: 'auth',
          meta: { title: '登录/注册' },
          children: [
            { path: 'login', meta: { title: '登录' } },
            { path: 'register', meta: { title: '注册' } }
          ]
        }]
      }

      return [{
        path: 'user',
        meta: { title: userEmail.value },
        children: [
          { path: 'profile', meta: { title: '个人中心' } },
          { path: 'logout', meta: { title: '退出登录' } }
        ]
      }]
    })

    // 直接从路由表中获取已转换的导航菜单数据，参考cloudApi页面的实现
    const navigationMenus = computed(() => {
      // 获取所有已注册的路由
      const allRoutes = router.getRoutes()

      // 筛选出顶级导航菜单路由
      const navigationRoutes = allRoutes.filter(route => {
        // 检查路由是否为顶级导航菜单（parentId为0且menuType为'M'）
        return route.meta?.menuType === 'M' &&
            route.meta?.parentId == 0 &&
            route.meta?.title && // 确保有标题
            route.path !== '/' // 排除根路径
      })

      // 按orderNum排序
      return navigationRoutes.sort((a, b) => (a.meta?.orderNum || 0) - (b.meta?.orderNum || 0))
    })

    console.log('导航菜单路由:', navigationMenus.value)

    const handleSelect = (key, keyPath) => {
      // 直接使用路由路径进行跳转，不需要手动查找菜单项
      if (key && key !== activeIndex.value) {
        console.log('页面发生了跳转', key)
        router.push(key)
      }
    }

    const handleCommand = (command) => {
      switch (command) {
        case 'logout':
          userStore.logout()
          router.push('/login')
          break
        case 'profile':
          // 检查当前是否已经在个人中心相关页面，如果是则不进行跳转
          const currentPath = route.path
          if (currentPath.startsWith('/personal-center') || currentPath.startsWith('/profile')) {
            return // 如果当前已在个人中心或申请页面，则不执行跳转
          }
          
          // 检查用户角色，如果角色ID为2，直接进入个人中心
          const userRoles = userStore.getRoles
          const hasRole2 = userRoles.some(role => role.id == 2)
          if (hasRole2) {
            // 角色为2的用户直接进入个人中心，不需要校验开发者状态
            router.push('/personal-center/audit-manage?auditStatus=0&pageNum=1&pageSize=10')
          } else if (userStore.getIsDeveloper) {
            // 其他角色的用户，如果是开发者，跳转到个人中心
            router.push('/personal-center')
          } else {
            // 其他角色的用户，如果不是开发者，跳转到申请成为开发者页面
            router.push('/profile')
          }
          break
        case 'login':
          router.push('/login')
          break
        case 'register':
          router.push('/register')
          break
      }
    }

    const handleUserMenuSelect = (key) => {
      handleCommand(key)
    }

    const goToHome = () => {
      router.push('/')
      activeIndex.value = '1'
    }

    return {
      activeIndex,
      isLoggedIn,
      username,
      userEmail,
      // userAvatar,
      navigationMenus,
      userMenus,
      handleSelect,
      handleCommand,
      handleUserMenuSelect,
      goToHome
    }
  }
}
</script>

<style scoped lang="scss">

.header-nav {
  background: #000;
  min-width: var(--body-content);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
  color: var(--color-white);
}

.nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--header-height);
  width: var(--body-content);
  margin: 0 auto;
  //min-width: var(--body-content);
}

.nav-left {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  margin-right: 80px;
}

.nav-main {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
}

/* .nav-left:hover {
  opacity: 0.8;
} */


.divider {
  width: 1px;
  height: 20px;
  background-color: #666;
  margin: 0 8px 0 10px;
}

.brand-name {
  font-size: 20px;
  font-weight: 500;
  white-space: nowrap;
}

.nav-menu {
  border-bottom: none;

}

.nav-right {
  display: flex;
  align-items: center;
  position: absolute;
  background-color: #000;
  right: 0;
  // top: 50%;
  // transform: translateY(-50%);
}

/* 当屏幕宽度低于1300px时，使用固定定位 */
@media (max-width: 1300px) {
  .nav-right {
    position: fixed;
  }
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;
  border: none;
}

.user-info:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.user-info:active {
  outline: none;
  border: none;
  box-shadow: none;
}

.username {
  margin: 0 8px;
  color: #fff;
}

.user-menu-wrapper {
  display: flex;
  align-items: center;
}

.auth-section {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.auth-buttons {
  display: flex;
  /* gap: 8px; */
  color: #fff;

}

.auth-buttons span {
  /* padding: 4px 8px; */
  font-size: 16px;
}

.auth-buttons span:hover {
  //color: #409eff;
  /* background-color: rgba(255, 255, 255, 0.1); */
}

/* 隐藏云开发子菜单的箭头 */
.nav-menu .el-sub-menu__icon-arrow {
  display: none !important;
}

.nav-menu .el-sub-menu .el-icon {
  display: none !important;
}

.logo {
  width: 119px;
  height: 18px;
  opacity: 1;
  background: url(https://img.js.design/assets/img/68a2c66a3f22157da6b4c2e8.png#e947494f18d44271259940c049483719);
  background-size: contain; /* 确保背景图片完整显示 */
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block; /* 使span元素能够应用宽高 */
}

//::v-deep .el-header {
//  padding: 0 !important;
//}
</style>
